import FormattedPercentage from 'I18n/components/FormattedPercentage';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DisplayValuePercentage({
  value
}) {
  return /*#__PURE__*/_jsx(FormattedPercentage, {
    precision: 2,
    stripInsignificantZeros: true,
    value: value * 100
  });
}